import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { TextField, Box, Button } from '@eatclubcode/ec-component-library';
import { COLORS, FONT_WEIGHTS } from '../../ObeeTheme';
import LeftCaret from '../../assets/left_caret.svg';
import LogoObee from '../../assets/logo_obee.svg';
import { devLog } from '../../utils';

const CustomSignIn = ({ authSignedIn }) => {
  const [restaurantId, setRestaurantId] = useState(
    localStorage.getItem('lastEnteredSlug') || import.meta.env?.VITE_DEFAULT_RESTAURANT || '',
  );
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!authSignedIn) {
      //     Clear the user if we need to log in
      //     sessionStorage.removeItem('selectedRestaurant');
      sessionStorage.removeItem('userId');
    }
  }, []);

  if (authSignedIn) {
    devLog('info', 'sign in', 'Already signed in');
    return null;
  }

  const backRedirectParam = import.meta.env.VITE_REDIRECT_LOGIN_URL
    ? `?redirect_url=${window.location.origin}/obeeLogin`
    : '';

  const signInUrl = `${import.meta.env.VITE_EXTERNAL_LOGIN_URL_START}${restaurantId}${
    import.meta.env.VITE_EXTERNAL_LOGIN_URL_END
  }${backRedirectParam}`;

  const handleSubmit = () => {
    localStorage.setItem('lastEnteredSlug', restaurantId);
    setSubmitting(true);

    window.location.href = signInUrl;
  };

  return (
    <Box>
      <Box
        style={{
          height: '80px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div style={{ width: '112px', height: '40px' }}>
          <LogoObee />
        </div>
      </Box>
      <Box style={{ backgroundColor: '#F5F5F5', textAlign: 'center' }}>
        <Box style={{ padding: '200px 20px' }}>
          <Box style={{ fontSize: '22px', paddingBottom: '40px' }}>
            Enter your venue&apos;s account name
          </Box>
          <Box>
            <Box
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
                flexWrap: 'wrap',
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  border: '1px solid #ddd',
                  backgroundColor: 'white',
                  alignItems: 'center',
                  height: '44px',
                  borderRadius: '4px',
                }}
              >
                <Box
                  style={{
                    padding: '12px',
                    color: '#008D62',
                    fontWeight: FONT_WEIGHTS.MEDIUM,
                  }}
                >
                  obee.com.au/
                </Box>
                <Box style={{ width: '260px' }}>
                  <TextField
                    value={restaurantId}
                    placeholder='accountname'
                    onChange={setRestaurantId}
                    style={{ input: { border: 'none' } }}
                    autoComplete
                    onEnter={handleSubmit}
                    autoCapitalize='none'
                  />
                </Box>
              </Box>
              <Button
                style={{ button: { borderRadius: '4px', backgroundColor: COLORS.BRAND_PRIMARY } }}
                loading={submitting}
                onEnter={handleSubmit}
                onClick={handleSubmit}
                newTab={false}
              >
                <Box
                  style={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '40px',
                  }}
                >
                  <Box>Continue</Box>
                  <LeftCaret style={{ transform: 'scaleX(-1)' }} />
                </Box>
              </Button>
            </Box>
          </Box>
        </Box>
        <Box
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '12px',
            paddingBottom: '40px',
          }}
        >
          <Box>Forgotten your account name?</Box>
          <Button
            type='text'
            style={{
              link: { color: COLORS.BRAND_PRIMARY },
              buttonHover: { textDecoration: 'underline' },
            }}
            href='https://help.obeeapp.com/article/48-obee-support'
          >
            Contact us
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

CustomSignIn.propTypes = {
  authSignedIn: PropTypes.bool.isRequired,
};

export default CustomSignIn;
